import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderPrimitive } from "posthog-js/react";
import { useEffect } from "react";
import config from "src/config";
import { getMeWithSitesDocument } from "src/features/organisation/graphql";
import { useGqlQuery } from "src/utils/hooks/graphql";

if (config.publicPostHogKey !== "unused") {
  posthog.init(config.publicPostHogKey, {
    api_host: config.publicPostHogHost,
    capture_pageview: true,
  });
}

export const PostHogProvider = ({
  children,
}: { children: React.ReactNode }) => {
  const { data } = useGqlQuery({
    query: getMeWithSitesDocument,
  });

  useEffect(() => {
    if (data?.me?.id) {
      posthog.identify(data.me.id, {
        email: data.me.email,
        name:
          data.me.givenName != null
            ? `${data.me.givenName} ${data.me.familyName}`
            : undefined,
      });
    }
  }, [data]);

  return (
    <PostHogProviderPrimitive client={posthog}>
      {children}
    </PostHogProviderPrimitive>
  );
};
